<template>
  <div>
    <el-dialog
        title="Cập nhật thêm thông tin"
        :before-close="handleClose"
        :visible.sync="isOpenUpdateAccountBankDialog"
        :show-close="true"
        :close-on-click-modal="false"
        width="700px"
        top="20vh"
        @open="handleOpen"
    >
      <el-form
          label-width="260px"
          :model="formData"
          label-position="left"
          ref="formData"
      >
        <el-form-item label="Thứ tự ưu tiên" prop="priority">
          <el-input-number
              v-if="bank.authenticationOTP === true && bank.bankApiConnected === true"
              style="width: 200px"
              v-model="formData.priority"
              :min="1"
          >
          </el-input-number>
          <el-input-number
              v-else
              style="width: 200px"
              v-model="formData.priority"
              :min="2"
          >
          </el-input-number>
        </el-form-item>
        <el-form-item label="Giới hạn hạn mức nhận vào trong tháng" prop="limit">
          <el-checkbox v-model="formData.limit"></el-checkbox>
        </el-form-item>
        <el-form-item label="Hạn mức nhận vào trong tháng" prop="moneyLimit" v-if="formData.limit === true">
          <el-input-number
              style="width: 200px"
              v-model="formData.moneyLimit"
              :min="1"
          >
          </el-input-number>
          <span style="margin-left: 10px">{{ formData.moneyLimit | formatCurrency }}</span>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
         <el-button
             type="success"
             size="medium"
             :loading="loading.submit"
             mini
             @click="submitForm()"
         >
        <i class="el-icon-circle-check"/>
        <span>Cập nhật</span>
      </el-button>
      <el-button
          type="danger"
          size="medium"
          @click="handleClose"
      >
        <i class="el-icon-circle-close"/>
        <span>Đóng</span>
      </el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>

import sePayConnectionService from "@/services/SePayConnectionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "UpdateAccountBankDialog",
  props: {
    isOpenUpdateAccountBankDialog: {
      type: Boolean,
      default: () => false
    },
    bank: {
      type: Object,
      default: () => null
    },
  },

  data() {
    return {
      formData: {
        priority: 1,
        moneyLimit:100000000,
        limit: false,
      },
      moneyLimit: "",
      loading: {
        submit: false,
      },
    }
  },

  methods: {
    handleClose() {
      this.formData.limit = false;
      this.formData.moneyLimit = 100000000;
      this.$refs["formData"].resetFields();
      this.$emit("closeDialog");
    },
    handleOpen() {
      this.formData.priority= this.$props.bank.priority;
      if (this.$props.bank.moneyLimit !== "unlimited") {
        this.formData.limit = true;
        this.formData.moneyLimit= this.$props.bank.moneyLimit;
      }
    },
    async submitForm() {
      this.$refs["formData"].validate(async (valid) => {
        if (valid) {
          this.loading.submit = true;
          if (this.formData.limit === false) {
            this.moneyLimit = "unlimited"
          } else {
            this.moneyLimit = this.formData.moneyLimit.toString()
          }
          await sePayConnectionService.updatePriority(this.$props.bank.id, this.formData.priority, this.moneyLimit).then((resp) => {
            if (resp.data.data === true) {
              NotifyMessage.leftCornerNotificationSuccess("Cập nhật thành công!")
            }else {
              NotifyMessage.leftCornerNotificationError("Cập nhật thất bại!")
            }
            this.handleClose()
            this.loading.submit = false;
          }).catch((err) => {
            console.log(err);
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>